webpackJsonp([9],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eventBus", function() { return eventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__locale_en_ts__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__locale_de_ts__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_i18n__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_design_icons_iconfont_dist_material_design_icons_css__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_material_design_icons_iconfont_dist_material_design_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_material_design_icons_iconfont_dist_material_design_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_dist_vuetify_min_css__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_StorageService__ = __webpack_require__(21);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




// Your own translation file








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_i18n__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a, {
  theme: {
    primary: '#008577',
    secondary: '#00574B',
    accent: '#008577',
    error: '#f44336',
    warning: '#ffeb3b',
    info: '#2196f3',
    success: '#4caf50'
  },
  lang: {
    // t: (key, ...params) => i18n.t(key, params),
    locales: { en: __WEBPACK_IMPORTED_MODULE_4__locale_en_ts__["a" /* default */], de: __WEBPACK_IMPORTED_MODULE_5__locale_de_ts__["a" /* default */] },
    current: navigator.language.startsWith('de') ? 'de' : 'en'
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

var eventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_9__components_StorageService__["a" /* storageService */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {},
  methods: {
    isNullOrEmpty: function isNullOrEmpty(s) {
      return s == null || s.trim().length == 0;
    }
  }
});

/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_StorageState__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_StringMixin__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DrawerMenu__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chenfengyuan_vue_qrcode__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    DrawerMenu: __WEBPACK_IMPORTED_MODULE_4__components_DrawerMenu__["a" /* default */],
    VueQrcode: __WEBPACK_IMPORTED_MODULE_5__chenfengyuan_vue_qrcode__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_StorageState__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_StringMixin__["a" /* default */]],
  data: function data() {
    return {
      drawer: false,
      menuItems: [],
      exportDialog: false,
      bookmarkDialog: false,
      title: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['state', 'uuid']), {
    userUuid: function userUuid() {
      return this.uuid == null ? '' : this.uuid;
    },
    online: function online() {
      return navigator.onLine;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['exportBikes', 'importBikes', 'refreshExport']), {
    isStateToSave: function isStateToSave(state) {
      return this.isUnsavedState(state);
    },
    clearStorage: function clearStorage() {
      localStorage.clear();
      window.location.href = '/';
    },
    menuClicked: function menuClicked(item) {
      __WEBPACK_IMPORTED_MODULE_6__main__["eventBus"].$emit('menu-selected', item.id);
    },
    toBookmarkUrl: function toBookmarkUrl() {
      // this.$router.push('/' + this.uuid);
      this.bookmarkDialog = true;
    },
    clickExportBikes: function clickExportBikes() {
      if (this.isNullOrEmpty(this.uuid)) {
        this.exportDialog = true;
      } else {
        this.exportBikes();
      }
    }
  }),
  mounted: function mounted(e) {
    __WEBPACK_IMPORTED_MODULE_6__main__["eventBus"].$on('title-change', function (e) {
      document.title = e;
      this.title = e;
    }.bind(this));
    __WEBPACK_IMPORTED_MODULE_6__main__["eventBus"].$on('menu-change', function (e) {
      if (e.menu) {
        this.menuItems = e.menu;
      }
    }.bind(this));
    // if (window.location.href.startsWith('http://localhost')) {
    //   this.createNewSettings();
    // }
    this.$store.commit('initMe', this.$vuetify);
  }
});

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_StringMixin__ = __webpack_require__(11);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'DrawerMenu',
  props: ['value'],
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_StringMixin__["a" /* default */]],
  data: function data() {
    var _this = this;

    return {
      showNewDialog: false,
      dialogContent: '',
      editItem: null,
      edit: false,
      inputRules: [function (v) {
        return !!v || _this.$vuetify.t('$vuetify.errormsg.required');
      }, function (v) {
        return v.length >= 3 || _this.$vuetify.t('$vuetify.errormsg.minlength');
      }],
      showPopupMenu: false,
      popupX: 0,
      popupY: 0,
      popupMenuItems: [],
      showDeleteDialog: false,
      isBike: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['allBikes']), {
    drawer: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['addBike', 'updateBike', 'deleteBike', 'addSetup', 'updateSetup', 'deleteSetup', 'copySetup']), {
    clickAddBike: function clickAddBike() {
      this.dialogContent = '';
      this.editItem = null;
      this.isBike = true;
      this.edit = false;
      this.showNewDialog = true;
    },
    newDialogOk: function newDialogOk() {
      if (!this.isNullOrEmpty(this.dialogContent)) {
        if (this.edit) {
          if (this.isBike) {
            this.updateBike({ name: this.dialogContent, bikeId: this.editItem.id });
          } else {
            this.updateSetup({ name: this.dialogContent, setupId: this.editItem.id, setup: { id: this.editItem.id } });
          }
        } else {
          if (this.isBike) {
            this.addBike({ name: this.dialogContent });
          } else {
            this.addSetup({ name: this.dialogContent, bikeId: this.editItem.id });
          }
        }
        this.showNewDialog = false;
      }
    },
    clickDeleteDialogOK: function clickDeleteDialogOK() {
      if (this.isBike) {
        this.deleteBike({ bikeId: this.editItem.id });
      } else {
        this.deleteSetup({ setupId: this.editItem.id });
      }
      this.showDeleteDialog = false;
    },
    showBikePopup: function showBikePopup(e, item) {
      var _this2 = this;

      e.preventDefault();
      this.editItem = item;
      this.showPopupMenu = false;
      this.popupX = e.clientX;
      this.popupY = e.clientY;
      this.popupMenuItems = [{ id: 'newbike', title: this.$vuetify.t('$vuetify.add_bike') }, { id: 'editbike', title: this.$vuetify.t('$vuetify.edit_bike') }, {
        id: 'deletebike',
        title: this.$vuetify.t('$vuetify.delete_bike')
      }, {
        id: 'newsetup',
        title: this.$vuetify.t('$vuetify.new_setup')
      }];
      this.$nextTick(function () {
        _this2.showPopupMenu = true;
      });
    },
    showSetupPopup: function showSetupPopup(e, item) {
      var _this3 = this;

      e.preventDefault();
      this.editItem = item;
      this.showPopupMenu = false;
      this.popupX = e.clientX;
      this.popupY = e.clientY;
      this.popupMenuItems = [{ id: 'copysetup', title: this.$vuetify.t('$vuetify.duplicate_setup') }, { id: 'deletesetup', title: this.$vuetify.t('$vuetify.delete_setup') }, { id: 'renamesetup', title: this.$vuetify.t('$vuetify.rename_setup') }];
      this.$nextTick(function () {
        _this3.showPopupMenu = true;
      });
    },
    clickedPopupMenu: function clickedPopupMenu(e) {
      switch (e) {
        case 'newbike':
          {
            this.clickAddBike();
            break;
          }
        case 'editbike':
          {
            this.dialogContent = this.editItem.name;
            this.edit = true;
            this.isBike = true;
            this.showNewDialog = true;
            break;
          }
        case 'deletebike':
          {
            this.dialogContent = this.editItem.name;
            this.isBike = true;
            this.showDeleteDialog = true;
            break;
          }
        case 'newsetup':
          {
            this.dialogContent = '';
            this.isBike = false;
            this.edit = false;
            this.showNewDialog = true;
            break;
          }
        case 'copysetup':
          {
            this.copySetup({ setup: JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.editItem)) });
            this.$router.push('' + this.$store.state.lastSetup.id);
            break;
          }
        case 'deletesetup':
          {
            this.dialogContent = this.editItem.name;
            this.isBike = false;
            this.showDeleteDialog = true;
            break;
          }
        case 'renamesetup':
          {
            this.dialogContent = this.editItem.name;
            this.isBike = false;
            this.edit = true;
            this.showNewDialog = true;
            break;
          }
      }
    }
  })
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var STORE_STATE = { INITIALIZED: 0, CLEAR: 1, UNSAVED: 2 };

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Home',
  data: function data() {
    var _this = this;

    return {
      inputRules: [function (v) {
        return !!v || _this.$vuetify.t('$vuetify.errormsg.required');
      }
      /*, v => v.length >= 3 || $vuetify.t('$vuetify.errormsg.minlength')*/
      ],
      uuid: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['state'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['createNewSettings', 'importBikes']), {
    isInitState: function isInitState(state) {
      return state == STORE_STATE.INITIALIZED;
    }
  }),
  mounted: function mounted(e) {
    if (this.$route.params.uuid) {
      this.uuid = this.$route.params.uuid;
    }
    __WEBPACK_IMPORTED_MODULE_2__main__["eventBus"].$emit('title-change', '');
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storageService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist__ = __webpack_require__(68);





__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

//fallback
var STORE_STATE = { INITIALIZED: 0, CLEAR: 1, UNSAVED: 2 };

var vuexPersist = new __WEBPACK_IMPORTED_MODULE_3_vuex_persist__["a" /* default */]({
  key: 'mybikesetup',
  storage: localStorage
});

var storageService = new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  strict: true,
  plugins: [vuexPersist.plugin],
  getters: {
    uuid: function uuid(state) {
      return state.uuid;
    },
    allBikes: function allBikes(state) {
      return state.bikes;
    },
    state: function state(s) {
      return s.state;
    },
    setup: function setup(state) {
      return function (setupId) {
        console.log('setup load');
        var list = [];

        var bikes = state.bikes;
        for (var i = 0; bikes != null && i != bikes.length; i++) {
          list = list.concat(bikes[i].setups);
        }
        console.log('setup load done');
        return list.find(function (setup) {
          return setup.id == setupId;
        });
      };
    },
    bike: function bike(state) {
      return function (bikeId) {
        return state.bikes.find(function (bike) {
          return bike.id == bikeId;
        });
      };
    },
    apiKey: function apiKey(state) {
      return state.apiKey;
    }
  },

  mutations: {
    createNewSettings: function createNewSettings(state) {
      state.bikes = state._defaultBikes;
      state.state = STORE_STATE.CLEAR;
    },

    updateSettings: function updateSettings(state, payload) {
      state.uuid = payload.uuid;
      state.revision = payload.revision;
      state.state = payload.state;
    },

    updateTodo: function updateTodo(state, payload) {
      var bike = state.bikes.find(function (b) {
        return b.id == payload.bikeId;
      });
      var todo = bike.todos.find(function (todo) {
        return todo.id == payload.todoId;
      });
      if (payload.checked) {
        todo.checked = payload.checked;
        state.state = STORE_STATE.UNSAVED;
      }
      if (payload.text) {
        todo.text = payload.text;
        state.state = STORE_STATE.UNSAVED;
      }
    },

    deleteTodo: function deleteTodo(state, payload) {
      var bike = state.bikes.find(function (b) {
        return b.id == payload.bikeId;
      });
      for (var i = 0; i != bike.todos.length; i++) {
        if (bike.todos[i].id == payload.todoId) {
          bike.todos.splice(i, 1);
          state.state = STORE_STATE.UNSAVED;
          break;
        }
      }
    },

    addTodo: function addTodo(state, payload) {
      var bike;
      var bikes = state.bikes;
      var newToDoId = 0;
      for (var i = 0; i != bikes.length; i++) {
        if (bikes[i].id == payload.bikeId) {
          bike = bikes[i];
        }

        for (var ti = 0; ti != bikes[i].todos.length; ti++) {
          if (bikes[i].todos[ti].id > newToDoId) {
            newToDoId = bikes[i].todos[ti].id;
          }
        }
      }
      if (bike == null) {
        return;
      }

      bike.todos.push({ id: newToDoId + 1, text: payload.text, checked: payload.checked });

      state.state = STORE_STATE.UNSAVED;
    },

    importBikes: function importBikes(state, payload) {
      state.bikes = payload.bikes;
      state.uuid = payload.uuid;
      state.revision = payload.revision;
      state.state = STORE_STATE.CLEAR;
    },

    addSetup: function addSetup(state, payload) {
      var bikes = state.bikes;
      var maxId = 0;
      var bike;
      for (var bi = 0; bi != bikes.length; bi++) {
        for (var i = 0; i !== bikes[bi].setups.length; i++) {
          if (bikes[bi].id == payload.bikeId) {
            bike = bikes[bi];
          }
          if (bikes[bi].setups[i].id > maxId) {
            maxId = bikes[bi].setups[i].id;
          }
        }
      }
      var newSetup = { name: payload.name, forkSetups: [], shockSetups: [], miscSetups: [], id: maxId + 1 };
      bike.setups.push(newSetup);
      state.lastSetup = newSetup;
      state.state = STORE_STATE.UNSAVED;
    },

    updateSetup: function updateSetup(state, payload) {
      var bikes = state.bikes;
      for (var bi = 0; bi != bikes.length; bi++) {
        var bike = bikes[bi];
        for (var i = 0; i !== bike.setups.length; i++) {
          if (bike.setups[i].id == payload.setup.id) {
            if (payload.setup) {
              bike.setups[i] = payload.setup;
              state.state = STORE_STATE.UNSAVED;
            }
            if (payload.name) {
              bike.setups[i].name = payload.name;
              state.state = STORE_STATE.UNSAVED;
            }
            return;
          }
        }
      }
    },
    deleteSetup: function deleteSetup(state, payload) {
      var bikes = state.bikes;
      for (var bi = 0; bi != bikes.length; bi++) {
        for (var i = 0; i < bikes[bi].setups.length; i++) {
          if (bikes[bi].setups[i].id == payload.setupId) {
            bikes[bi].setups.splice(i, 1);
            state.state = STORE_STATE.UNSAVED;
          }
        }
      }
    },

    copySetup: function copySetup(state, payload) {
      var bikes = state.bikes;
      var maxId = 0;
      var bike;
      var newSetup = payload.setup;
      for (var bi = 0; bi != bikes.length; bi++) {
        for (var i = 0; i !== bikes[bi].setups.length; i++) {
          if (bikes[bi].setups[i].id == newSetup.id) {
            bike = bikes[bi];
          }
          if (bikes[bi].setups[i].id > maxId) {
            maxId = bikes[bi].setups[i].id;
          }
        }
      }
      newSetup.id = maxId + 1;
      bike.setups.push(newSetup);
      state.lastSetup = newSetup;
      state.state = STORE_STATE.UNSAVED;
    },

    addBike: function addBike(state, payload) {
      var bikes = state.bikes;
      var maxId = 0;
      for (var i = 0; i !== bikes.length; i++) {
        if (bikes[i].id > maxId) {
          maxId = bikes[i].id;
        }
      }

      state.bikes.push({
        id: maxId + 1,
        name: payload.name,
        todos: [],
        setups: [state._defaultSetup]
      });
      state.state = STORE_STATE.UNSAVED;
    },

    updateBike: function updateBike(state, payload) {
      var bike = state.bikes.find(function (b) {
        return b.id == payload.bikeId;
      });
      if (bike != null) {
        bike.name = payload.name;
        state.state = STORE_STATE.UNSAVED;
      }
    },

    deleteBike: function deleteBike(state, payload) {
      var bikes = state.bikes;
      for (var i = 0; i != bikes.length; i++) {
        if (bikes[i].id == payload.bikeId) {
          bikes.splice(i, 1);
          state.state = STORE_STATE.UNSAVED;
          break;
        }
      }
    },

    updateApiKey: function updateApiKey(state, payload) {
      state.apiKey = payload;
    },
    initMe: function initMe(state, $vuetify) {
      state._defaultSetup = {
        'forkSetups': [{ 'name': $vuetify.t('$vuetify.setuptype.pressure'), 'value': '123' }, { 'name': 'Lowspeed Rebound', 'value': '3' }, {
          'name': 'Highspeed Rebound',
          'value': '5'
        }, { 'name': 'Lowspeed Compression', 'value': '1' }, { 'name': 'Heighspeed Compression', 'value': '0' }],
        'id': 1,
        'miscSetups': [{ 'name': $vuetify.t('$vuetify.setuptype.pressure_front'), 'value': '1.7' }, { 'name': $vuetify.t('$vuetify.setuptype.tire_rear'), 'value': '1.8' }],
        'name': 'General',
        'shockSetups': [{ 'name': $vuetify.t('$vuetify.setuptype.spring'), 'value': '500' }, { 'name': 'Rebound', 'value': '5' }, { 'name': 'Compression', 'value': '5' }]
      };

      state._defaultBikes = [{
        'id': 1,
        'name': 'Bike1',
        'setups': [{
          'forkSetups': [{ 'name': $vuetify.t('$vuetify.setuptype.pressure'), 'value': '123' }, { 'name': 'Lowspeed Rebound', 'value': '3' }, {
            'name': 'Highspeed Rebound',
            'value': '5'
          }, { 'name': 'Lowspeed Compression', 'value': '1' }, { 'name': 'Heighspeed Compression', 'value': '0' }],
          'id': 1,
          'miscSetups': [{ 'name': $vuetify.t('$vuetify.setuptype.pressure_front'), 'value': '1.7' }, { 'name': $vuetify.t('$vuetify.setuptype.tire_rear'), 'value': '1.8' }],
          'name': 'General',
          'shockSetups': [{ 'name': $vuetify.t('$vuetify.setuptype.spring'), 'value': '500' }, { 'name': 'Rebound', 'value': '5' }, { 'name': 'Compression', 'value': '5' }]
        }, {
          'forkSetups': [{ 'name': $vuetify.t('$vuetify.setuptype.pressure'), 'value': '1231' }, { 'name': 'Highspeed Rebound', 'value': '51' }, {
            'name': 'Highspeed Compression',
            'value': '10'
          }],
          'id': 2,
          'miscSetups': [],
          'name': 'Setup 2',
          'shockSetups': [{ 'name': $vuetify.t('$vuetify.setuptype.pressure'), 'value': '200' }, { 'name': 'Rebound', 'value': '5' }, { 'name': 'Compression', 'value': '5' }]
        }, {
          'forkSetups': [{ 'name': $vuetify.t('$vuetify.setuptype.pressure'), 'value': '123' }, { 'name': 'Lowspeed Rebound', 'value': '3' }, {
            'name': 'Highspeed Rebound',
            'value': '5'
          }, { 'name': 'Lowspeed Compression', 'value': '1' }, { 'name': 'Highspeed Compression', 'value': '0' }], 'id': 3, 'miscSetups': [], 'name': 'Setup 3', 'shockSetups': []
        }],
        'todos': [{ 'checked': false, 'id': 1, 'text': 'Todo1' }, { 'checked': true, 'id': 2, 'text': 'Todo2' }, { 'checked': false, 'id': 3, 'text': 'Todo3' }, {
          'checked': false,
          'id': 4,
          'text': 'Todo 1'
        }, { 'checked': true, 'id': 5, 'text': 'Todo 2' }, { 'checked': false, 'id': 6, 'text': 'Todo 4' }]
      }, {
        'id': 2,
        'name': 'Bike2',
        'setups': [{
          'forkSetups': [{ 'name': $vuetify.t('$vuetify.setuptype.pressure'), 'value': '123' }, { 'name': 'Lowspeed Rebound', 'value': '3' }, {
            'name': 'Highspeed Rebound',
            'value': '5'
          }, { 'name': 'Lowspeed Compression', 'value': '1' }, { 'name': 'Highspeed Compression', 'value': '0' }],
          'id': 4,
          'miscSetups': [{ 'name': $vuetify.t('$vuetify.setuptype.pressure_front'), 'value': '1.7' }, { 'name': $vuetify.t('$vuetify.setuptype.tire_rear'), 'value': '1.8' }],
          'name': 'Basic',
          'shockSetups': [{ 'name': $vuetify.t('$vuetify.setuptype.spring'), 'value': '500' }, { 'name': 'Rebound', 'value': '5' }, { 'name': 'Compression', 'value': '5' }]
        }],
        'todos': []
      }, { 'id': 3, 'name': 'Bike3', 'setups': [], 'todos': [] }];
    }
  },

  actions: {
    createNewSettings: function createNewSettings(context, payload) {
      context.commit('createNewSettings');
    },

    importBikes: function importBikes(context, payload) {
      var uuid = payload;
      if (uuid && uuid.length > 1) {
        fetch('https://whbe.mybikesetup.net/storage/' + uuid).then(function (response) {
          var contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            return response.json();
          }
          throw new TypeError('Oops, we haven\'t got JSON!');
        }).then(function (json) {
          if (json.id) {
            var bikeData = JSON.parse(json.value);
            if (bikeData) {
              context.commit('importBikes', { bikes: bikeData, uuid: json.uuid, revision: json.id });
            }
          }
        }).catch(function (error) {
          console.error(error);
        });
      }
    },

    exportBikes: function exportBikes(context) {
      if (context.state.state == STORE_STATE.CLEAR) {
        return;
      }

      var uuid = context.state.uuid;
      if (!uuid || uuid.trim().length == 0) {
        uuid = guid() + guid() + guid();
      }

      fetch('https://whbe.mybikesetup.net/storage/' + uuid, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(context.state.bikes)
      }).then(function (response) {
        return response.text();
      }).then(function (id) {
        if (id) {
          context.commit('updateSettings', { uuid: uuid, revision: id, state: STORE_STATE.CLEAR });
        } else {
          console.error(':-(');
        }
      }).catch(function (error) {
        console.error(error);
      });

      //helper methods
      function guid() {
        return 'ssssssss'.replace(/s/g, s4);
      }

      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      }
    },

    refreshExport: function refreshExport(context) {
      if (!context.state.uuid || context.state.uuid.trim().length === 0) {
        return;
      }

      fetch('https://whbe.mybikesetup.net/storage/' + context.state.uuid).then(function (response) {
        var contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          return response.json();
        }
        throw new TypeError('Oops, we haven\'t got JSON!');
      }).then(function (json) {
        if (json.id) {
          if (json.id > context.state.revision) {
            var bikeData = JSON.parse(json.value);
            if (bikeData) {
              context.commit('importBikes', { bikes: bikeData, uuid: json.uuid, revision: json.id });
            }
          } else {
            context.dispatch('exportBikes');
          }
        }
      }).catch(function (error) {
        console.error(error);
      });
    },

    addSetup: function addSetup(context, payload) {
      context.commit('addSetup', payload);
    },
    updateSetup: function updateSetup(context, payload) {
      context.commit('updateSetup', payload);
    },
    copySetup: function copySetup(context, payload) {
      context.commit('copySetup', payload);
    },
    deleteSetup: function deleteSetup(context, payload) {
      context.commit('deleteSetup', payload);
    },

    addTodo: function addTodo(context, payload) {
      context.commit('addTodo', payload);
    },
    deleteTodo: function deleteTodo(context, payload) {
      context.commit('deleteTodo', payload);
    },
    updateTodo: function updateTodo(context, payload) {
      context.commit('updateTodo', payload);
    },

    addBike: function addBike(context, payload) {
      context.commit('addBike', payload);
    },
    updateBike: function updateBike(context, payload) {
      context.commit('updateBike', payload);
    },
    deleteBike: function deleteBike(context, payload) {
      context.commit('deleteBike', payload);
    },
    updateApiKey: function updateApiKey(context, payload) {
      context.commit('updateApiKey', payload);
    }
  },

  state: {
    state: 0,
    revision: -1,
    uuid: null,
    bikes: [],
    lastSetup: null,
    _defaultSetup: null,
    _defaultBikes: null,
    apiKey: ''
  }
});

/***/ }),
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_Home__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StorageService__ = __webpack_require__(21);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: Object({"NODE_ENV":"production"}).BASE_URL,
  routes: [{
    path: '/setup/:setupId',
    name: 'Setup',
    component: function component() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 80));
    }
  }, {
    path: '/todos/:bikeId',
    name: 'Todos',
    component: function component() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 81));
    }
  }, {
    path: '/inprint',
    name: 'Inprint',
    component: function component() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 82));
    }
  }, {
    path: '/springcalculator',
    name: 'Spring Calculator',
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 83));
    }
  }, {
    path: '/spokecalculator',
    name: 'Spoke Calculator',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 84));
    }
  }, {
    path: '/login',
    name: 'Login',
    component: function component() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 85));
    }
  }, {
    path: '/admin/hubs',
    name: 'Hubs Admin',
    component: function component() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 86));
    },
    meta: {
      private: true,
      onlyWhenLoggedOut: true
    }
  }, {
    path: '/admin/rims',
    name: 'Rims Admin',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 87));
    },
    meta: {
      private: true,
      onlyWhenLoggedOut: true
    }
  }, {
    path: '/:uuid?',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__views_Home__["a" /* default */]
  }]
});

router.beforeEach(function (to, from, next) {
  var isPrivate = to.matched.some(function (record) {
    return record.meta.private;
  });
  console.log(__WEBPACK_IMPORTED_MODULE_3__components_StorageService__["a" /* storageService */].state.apiKey);
  if (isPrivate && (__WEBPACK_IMPORTED_MODULE_3__components_StorageService__["a" /* storageService */].state.apiKey == null || __WEBPACK_IMPORTED_MODULE_3__components_StorageService__["a" /* storageService */].state.apiKey == '')) {
    return next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
  }

  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(13);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22ac2f0c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(63);
function injectStyle (ssrContext) {
  __webpack_require__(28)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-22ac2f0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22ac2f0c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
var STORE_STATE = { INITIALIZED: 0, CLEAR: 1, UNSAVED: 2 };

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {},
  methods: {
    isInitState: function isInitState(state) {
      return state == STORE_STATE.INITIALIZED;
    },
    isClearState: function isClearState(state) {
      return state == STORE_STATE.CLEAR;
    },
    isUnsavedState: function isUnsavedState(state) {
      return state == STORE_STATE.UNSAVED;
    },
    getInitState: function getInitState() {
      return STORE_STATE.INITIALIZED;
    },
    getUnsavedState: function getUnsavedState() {
      return STORE_STATE.UNSAVED;
    },
    getSavedState: function getSavedState() {
      return STORE_STATE.CLEAR;
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawerMenu_vue__ = __webpack_require__(19);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eeed62b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawerMenu_vue__ = __webpack_require__(61);
function injectStyle (ssrContext) {
  __webpack_require__(59)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eeed62b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DrawerMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eeed62b2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DrawerMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */,
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"app":"","fixed":"","clipped":"","mobile-break-point":1100},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',[_vm._l((_vm.allBikes),function(bike){return _c('v-list-group',{key:bike.id},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-action',{on:{"contextmenu":function($event){return _vm.showBikePopup($event, bike)}}}),_vm._v(" "),_c('v-list-tile-content',{staticClass:"subheading",on:{"contextmenu":function($event){return _vm.showBikePopup($event, bike)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(bike.name))])],1)],1),_vm._v(" "),_vm._l((bike.setups),function(item){return _c('v-list-tile',{key:item.id,attrs:{"to":{path: '/setup/' + item.id}},on:{"contextmenu":function($event){return _vm.showSetupPopup($event, item)}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("build")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1)],1)}),_vm._v(" "),_c('v-list-tile',{attrs:{"to":{path: '/todos/' + bike.id}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("list")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Todos")])],1)],1)],2)}),_vm._v(" "),_c('v-list-tile',{attrs:{"to":"/springcalculator"}},[_c('v-list-tile-action',[_c('v-img',{staticClass:"menu-icon",attrs:{"src":"/static/svg/calc_spring.svg"}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.menu.spring_calculator')))])],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"to":"/spokecalculator"}},[_c('v-list-tile-action',[_c('v-img',{staticClass:"menu-icon",attrs:{"src":"/static/svg/calc_spoke.svg"}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.menu.spoke_calculator'))+" (Beta)")])],1)],1)],2),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.clickAddBike}},[_c('v-icon',[_vm._v("add")]),_vm._v("\n    "+_vm._s(_vm.$vuetify.t('$vuetify.add_bike'))+"\n  ")],1),_vm._v(" "),_c('v-menu',{attrs:{"position-x":_vm.popupX,"position-y":_vm.popupY,"absolute":"","offset-y":""},model:{value:(_vm.showPopupMenu),callback:function ($$v) {_vm.showPopupMenu=$$v},expression:"showPopupMenu"}},[_c('v-list',_vm._l((_vm.popupMenuItems),function(item){return _c('v-list-tile',{key:item.id,on:{"click":function($event){return _vm.clickedPopupMenu(item.id)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)}),1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.showNewDialog),callback:function ($$v) {_vm.showNewDialog=$$v},expression:"showNewDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.' + (_vm.edit? 'edit ': 'new')))+" "+_vm._s(_vm.isBike ? 'Bike' : 'Setup'))]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"placeholder":_vm.isBike ? 'Bike' : 'Setup',"rules":_vm.inputRules},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.dialogOk($event)}},model:{value:(_vm.dialogContent),callback:function ($$v) {_vm.dialogContent=$$v},expression:"dialogContent"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.edit)?_c('v-btn',{attrs:{"outline":"","flat":"flat"},domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.cancel'))},on:{"click":function($event){_vm.showNewDialog = false}}},[_vm._v("\n          Cancel\n        ")]):_vm._e(),_vm._v(" "),(_vm.edit)?_c('v-btn',{attrs:{"outline":"","color":"red","flat":"flat"},domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.delete'))},on:{"click":_vm.clickDeleteDialogOK}},[_vm._v("\n          Delete\n        ")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","flat":"flat"},domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.ok'))},on:{"click":_vm.newDialogOk}},[_vm._v("\n          OK\n        ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.showDeleteDialog),callback:function ($$v) {_vm.showDeleteDialog=$$v},expression:"showDeleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.app.dialog.delete_title'))+" "+_vm._s(_vm.isBike ? 'Bike' : 'Setup'))]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        "+_vm._s(_vm.$vuetify.t('$vuetify.app.dialog.delete_start'))+" "+_vm._s(_vm.isBike ? 'Bike' : 'Setup')+" \""+_vm._s(_vm.dialogContent)+"\" "+_vm._s(_vm.$vuetify.t('$vuetify.app.dialog.delete_end'))+"\n      ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","flat":"flat"},domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.cancel'))},on:{"click":function($event){_vm.showDeleteDialog = false}}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","flat":"flat"},domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.ok'))},on:{"click":_vm.clickDeleteDialogOK}},[_vm._v("\n          OK\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 62 */,
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('drawer-menu',{model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}}),_vm._v(" "),_c('v-toolbar',{attrs:{"app":"","fixed":"","clipped-left":"","color":"primary"}},[_c('v-toolbar-side-icon',{staticClass:"white--text",on:{"click":function($event){_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',{staticClass:"white--text"},[_c('a',{staticClass:"white--text",attrs:{"href":"/"}},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.isStateToSave(_vm.state))?_c('v-btn',{attrs:{"flat":"","title":_vm.$vuetify.t('$vuetify.app.menu.save_toserver'),"disabled":!_vm.online},on:{"click":_vm.clickExportBikes}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("save_alt")])],1):_vm._e(),_vm._v(" "),_c('v-menu',{attrs:{"bottom":"","left":"","v1-if":"menuItems.length != 0"}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_vm._l((_vm.menuItems),function(menu){return _c('v-list-tile',{key:menu.id,on:{"click":function($event){return _vm.menuClicked(menu)}}},[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v(_vm._s(menu.icon))])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(menu.title))])],1)}),_vm._v(" "),_c('v-list-tile',{on:{"click":_vm.clearStorage}},[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("block")])],1),_vm._v(" "),_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.app.menu.clear_storage'))}},[_vm._v("\n            Clear Storage\n          ")])],1),_vm._v(" "),(_vm.uuid && _vm.uuid != '')?_c('v-list-tile',{on:{"click":_vm.toBookmarkUrl}},[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("bookmark_border")])],1),_vm._v(" "),_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.app.menu.bookmark'))}},[_vm._v("\n            Bookmark URL\n          ")])],1):_vm._e(),_vm._v(" "),(_vm.uuid && _vm.uuid != '')?_c('v-list-tile',{attrs:{"disabled":!_vm.online},on:{"click":_vm.refreshExport}},[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("cached")])],1),_vm._v(" "),_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.app.menu.refresh'))}},[_vm._v("\n            Refresh\n          ")])],1):_vm._e(),_vm._v(" "),(_vm.$vuetify.lang.current != 'de')?_c('v-list-tile',{on:{"click":function($event){_vm.$vuetify.lang.current ='de'}}},[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("language")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("\n            Deutsch\n          ")])],1):_vm._e(),_vm._v(" "),(_vm.$vuetify.lang.current != 'en')?_c('v-list-tile',{on:{"click":function($event){_vm.$vuetify.lang.current ='en'}}},[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("language")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("\n            English\n          ")])],1):_vm._e()],2)],1)],1),_vm._v(" "),_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1),_vm._v(" "),_c('v-footer',{staticClass:"pa-3"},[_c('v-spacer'),_vm._v(" "),_c('div',[_vm._v("© "+_vm._s(new Date().getFullYear())+"\n      "),_c('router-link',{attrs:{"to":"/inprint"},domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.inprint.title'))}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"380"},model:{value:(_vm.exportDialog),callback:function ($$v) {_vm.exportDialog=$$v},expression:"exportDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline",domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.app.dialog.store_title'))}},[_vm._v("Store everything on server?")]),_vm._v(" "),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.app.dialog.store_msg'))}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","outline":""},domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.disagree'))},on:{"click":function($event){_vm.exportDialog = false}}},[_vm._v("\n          Disagree\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","outline":"","color":"green"},domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.agree'))},on:{"click":function($event){_vm.exportDialog = false; _vm.exportBikes();}}},[_vm._v("\n          Agree\n        ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400px"},model:{value:(_vm.bookmarkDialog),callback:function ($$v) {_vm.bookmarkDialog=$$v},expression:"bookmarkDialog"}},[_c('v-card',{attrs:{"max-width":"400px"}},[_c('v-card-title',[_c('h1',[_vm._v("Bookmark/Share")])]),_vm._v(" "),_c('v-card-text',[_c('div',[_vm._v("Scanne diesen QR Code mit deinem Android gerät oder speichere dir die "),_c('a',{staticStyle:{"max-width":"350px"},attrs:{"target":"_blank","href":'/'+_vm.uuid}},[_vm._v("Adresse")])]),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('VueQrcode',{attrs:{"value":_vm.uuid,"options":{ width: 200 }}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","outline":"","color":"green"},on:{"click":function($event){_vm.bookmarkDialog = false}}},[_vm._v("OK")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 64 */,
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(20);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73ad3d1d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(67);
function injectStyle (ssrContext) {
  __webpack_require__(66)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73ad3d1d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73ad3d1d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"card"},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v("MyBikeSetup")]),_vm._v(" "),_c('v-card-title',{domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.home.title'))}}),_vm._v(" "),_c('v-card-text',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.home.mainmessage'))}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.isInitState(this.state))?_c('div',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.home.initial_question'))}}),_vm._v(" "),_c('div',{staticClass:"section"},[_c('v-text-field',{attrs:{"label":"User ID","rules":_vm.inputRules},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.importBikes(_vm.uuid)}},model:{value:(_vm.uuid),callback:function ($$v) {_vm.uuid=$$v},expression:"uuid"}}),_vm._v(" "),_c('v-btn',{domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.home.components.load_configuration'))},on:{"click":function($event){return _vm.importBikes(_vm.uuid)}}})],1),_vm._v(" "),_c('div',{staticClass:"create-area mt-2"},[_c('div',{staticClass:"create-text",domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.home.noconfig_answer'))}}),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","outline":""},on:{"click":_vm.createNewSettings}},[_c('v-icon',[_vm._v("build")])],1)],1)]):_c('div',{domProps:{"innerHTML":_vm._s(_vm.$vuetify.t('$vuetify.home.existing_configmsg'))}})])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  "home": {
    "title": "Hey you found the MyBikeSetup WebApp, and now?",
    "mainmessage": "Beside our <a href=\"https://play.google.com/store/apps/details?id=net.byte_welt.eagleeye.mybikesetup\" target=\"_blank\">Android App</a> now there is this WebApp.<br>Since we are, well me, currently only maintain the Android, there is this web app for all other platforms. If your browser works fine, you have the same features as Android. In addition, the app should be running without an internet connection, unless you have safari ...<br>But you can store your data on the server, like in the Android App, also sync with this app.",
    "initial_question": "There is no local configuration, what sould happen:<br>Do you have a user id, then enter it:",
    "noconfig_answer": "You hasn't something? Then create here some sample configuration",
    "existing_configmsg": "Oh there is a configuration, let's go.",
    "components": {
      "load_configuration": "Load configuration",
      "create_new": "Create new"
    }
  },
  "menu": {
    "spring_calculator": "Spring Calculator",
    "spoke_calculator": "Spoke Calculator"
  },
  "app": {
    "menu": {
      "clear_storage": "Clear storage",
      "refresh": "Refresh",
      "bookmark": "Bookmark/Share",
      "save_toserver": "Save to server"
    },
    "dialog": {
      "store_title": "Store everything on server?",
      "store_msg": "If you aggree all configurations will be stored on a server and could be accessed by the user id. <br>Besite the configuration, no data will be stored. For backup purposes store your user id, later you can add these backup to an other device or reload for backup.<br>If you disagree, every stays only stored in your browser and will be deleted if you erased your browser local storage.",
      "delete_start": "Should this",
      "delete_end": "really been deleted? ",
      "delete_title": "Delete",
    }
  },
  "todo": {
    "addfab": "Add ToDo",
    "editbtn": "Edit ToDo",
    "dialog": {
      "edittitle": "Edit ToDo",
      "newtitle": "New ToDo",
    }
  },
  "setup": {
    "setuptitle": "Setup title",
    "menu": {},
    "setupitem": {
      "selecttype": "Select type",
    }
  },
  "calc": {
    "title": "Spring calculator",
    "topmsg": "To calculate your spring rate, you need to enter some details. The result is a theoretical calculated recommendation, it can vary by your personal preferences and your bike. If you ride a very heavy bike, like an ebike you should add some additional weight, depending of motor and battery 3-8kg.",
    "riderweight": "Rider weight",
    "shockstroke": "Shock stroke",
    "wheeltravel": "Wheel travel",
    "singlepivot_title": "Singlepivot/DW-Link",
    "vpp_title": "4 Bar/VPP/4 Link",
    "results": "Results",
    "sag": {
      "label": "Sag",
      "plush": "Plush",
      "firm": "Firm"
    }
  },
  "setuptype": {
    "pressure": "Pressure",
    "spring": "Spring",
    "tire_front": "Tire front",
    "tire_rear": "Tire rear",
    "pressure_front": "Pressure front",
    "pressure_rear": "Pressure rear",
    "chainring": "Chainring"
  },
  "errormsg": {
    "minlength": "Minimum length is 3 characters",
    "required": "This field is required"
  },
  "spoke": {
    "title": "Spoke Calculator",
    "hub_title": "Hub",
    "hub_manufacturers_select": "Manufacturer",
    "hub_select_title": "Model",
    "rim_title": "Rim",
    "rim_manufacturers_select": "Manufacturer",
    "rim_select_title": "Model",
    "hub_rear": "rear",
    "hub_front": "front",
    "result_title": "Result",
    "spoke_count": "Spoke count",
    "spoke_crossing": "Spoke crossing",
    "spoke_length_left": "Spoke length left:",
    "spoke_length_right": "Spoke length right:",
    "exact": "exact",
    "recommended": "recommended"
  },
  "inprint": {"title": "Inprint"},
  "noDataText": "No data available",
  "agree": "Agree",
  "disagree": "Disagree",
  "ok": "OK",
  "cancel": "Cancel",
  "delete": "Delete",
  "fork": "Fork",
  "shock": "Shock",
  "misc": "Misc",
  "add_bike": "Add bike",
  "edit": "Edit",
  "new": "New",
  "duplicate_setup": "Duplicate setup",
  "delete_setup": "Delete setup",
  "rename_setup": "Rename setup",
  "delete_bike": "Delete bike",
  "edit_bike": "Edit bike",
  "edit_setup": "Edit setup",
  "new_setup": "New Setup",
  "save": "Save"
});


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  "home": {
    "title": "Hey du hast es geschafft auf die MyBikeSetup WebApp zu kommen und was willst du jetzt hier?",
    "mainmessage": "Neben unserer <a href=\"https://play.google.com/store/apps/details?id=net.byte_welt.eagleeye.mybikesetup\" target=\"_blank\">Android App</a> gibt es jetzt auch diese WebApp. Da wir, naja ich, aktuell nur noch die Android pflegen gibt es für alle anderen Plattformen diese WebApp.<br><br>Wenn euer Browser mitspielt habt ihr die selben funktionen wie bei Google.Ihr könnt hier eure Konfigurationen anlegen, bearbeiten und speichern, dabei werden alle Daten lokal in eurem Browser gespeichert. Browser zu, Browser auf und die Daten sind noch da (außer der Browser macht Mist und räumt auf, naaaa Apple 😜).<br>Außerdem sollte die App auch ohne Internetverbindung lauffähig sein, außer ihr habt einen Safari .... <br>Aber ihr könnt wie bei Android auch die Daten aufm Server speichern lassen oder vom Android holen.",
    "initial_question": "Es gibt lokal keine Konfiguration, was soll passieren:<br>Hast du schon eine User ID, dann gib sie hier ein",
    "noconfig_answer": "Du hast nichts? Dann lass dir hier eine Beispielkonfiguration erzeugen",
    "existing_configmsg": "Oh es gibt hier eine Konfiguration, na dann auf get's.",
    "components": {
      "load_configuration": "Konfiguration laden",
      "create_new": "Neue erstellen"
    }
  },
  "menu": {
    "spring_calculator": "Federhärten Rechner",
    "spoke_calculator": "Speichenrechner"
  },
  "app": {
    "menu": {
      "clear_storage": "Speicher löschen",
      "refresh": "Aktualisieren",
      "bookmark": "Bookmark/Share",
      "save_toserver": "Auf Server speichern"
    },
    "dialog": {
      "store_title": "Auf Server speichern?",
      "store_msg": "Wenn du zustimmst, werden alle Konfigurationen auf einem Server gespeichert und können über die User ID erreicht werden.<br>Außer der Konfiguration werden keine weiteren Daten gespeichert. Um diese Daten wieder zu erreichen solltest du die User ID speichern, mit dieser kannst du die Konfiguration auf anderen Geräten synchronisieren. Wenn du nicht zustimmst bleiben die Daten lokal im Browser gespeichert und werden gelöscht wenn du den Browser Speicher löschst.",
      "delete_start": "Soll dieses",
      "delete_end": "wirklich gelöscht werden? ",
      "delete_title": "Lösche",
    }
  },
  "todo": {
    "addfab": "ToDo hinzufügen",
    "editbtn": "ToDo bearbeiten",
    "dialog": {
      "edittitle": "ToDo Bearbeiten",
      "newtitle": "Neues ToDo",
    }
  },
  "setup": {
    "setuptitle": "Setup Titel",
    "menu": {},
    "setupitem": {
      "selecttype": "Typ auswählen",
    }
  },
  "calc": {
    "title": "Federhärten Rechner",
    "topmsg": "Um die Federhärte zu berechnen musst du uns mir ein paar Details verraten. Das Ergebnis ist eine berechnete Empfehlung, welche durch die persönlichen Vorlieben und deinem Rad abweichen kann. Wenn du ein schweres Rad, wie z.B. ein E-Bike fährst, dann solltest du zusätzliches Gewicht, in Abhhängigkeit von Motor und Batterie (3-8kg) mit einbeziehen.",
    "riderweight": "Fahrergewicht",
    "shockstroke": "Hub",
    "wheeltravel": "Federweg",
    "singlepivot_title": "Eingelenker/DW-Link",
    "vpp_title": "Viergelenker/VPP/4 Link",
    "results": "Ergebnis",
    "sag": {
      "label": "Sag",
      "plush": "Weich",
      "firm": "Straff"
    }
  },
  "setuptype": {
    "pressure": "Druck",
    "spring": "Feder",
    "tire_front": "Reifen vorn",
    "tire_rear": "Reifen hinten",
    "pressure_front": "Druck vorn",
    "pressure_rear": "Druck hinten",
    "chainring": "Kettenblatt"
  },
  "inprint": {"title": "Impressum"},
  "errormsg": {
    "minlength": "Mindestlänge 3 Zeichen",
    "required": "Die Eingabe ist erforderlich"
  },
  "spoke": {
    "title": "Speichenrechner",
    "hub_title": "Nabe",
    "hub_manufacturers_select": "Hersteller",
    "hub_select_title": "Modell",
    "rim_title": "Felge",
    "rim_manufacturers_select": "Hersteller",
    "rim_select_title": "Modell",
    "hub_rear": "hinten",
    "hub_front": "vorn",
    "result_title": "Ergebnis",
    "spoke_count": "Speichenanzahl",
    "spoke_crossing": "Kreuzungen",
    "spoke_length_left": "Speichenlänge links:",
    "spoke_length_right": "Speichenlänge rechts:",
    "exact": "exakt",
    "recommended": "empfohlen"
  },
  "noDataText": "Keine Daten verfügbar",
  "agree": "Zustimmen",
  "disagree": "Nix da",
  "ok": "OK",
  "cancel": "Abbrechen",
  "delete": "Löschen",
  "fork": "Gabel",
  "shock": "Dämpfer",
  "misc": "Div",
  "add_bike": "Bike hinzufügen",
  "edit": "Bearbeiten",
  "new": "Neues",
  "duplicate_setup": "Setup duplizieren",
  "delete_setup": "Setup löschen",
  "rename_setup": "Setup umbennen",
  "delete_bike": "Bike löschen",
  "edit_bike": "Bike bearbeiten",
  "edit_setup": "Setup bearbeiten",
  "new_setup": "Neues Setup",
  "save": "Speichern",
  "dataIterator": {
    "prevPage": "<",
    "nextPage": ">",
    "pageText": "{0}-{1} von {2}",
    "rowsPerPageAll": "All"
  },
  "dataTable": {
    "rowsPerPageText": "Zeilen"
  }
});


/***/ }),
/* 75 */,
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[5]);


// WEBPACK FOOTER //
// static/js/app.49780822e35ccbf1d93a.js